import SubstanceTrackerLogs from './SubstanceTrackerLogs';

export default SubstanceTrackerLogs;
